import axios from 'axios';

const { VUE_APP_BASE_URL } = process.env;

export const fetchSkuAvailability = async (projectId, listName = '', params) => {
  if (listName !== '') {
    // eslint-disable-next-line no-param-reassign
    params.list_tab = listName;
  }

  return axios({
    url: `/projects/${projectId}/sku/availability`,
    baseURL: `${VUE_APP_BASE_URL}/api/ocean/v3/`,
    params
  });
};

export const fetchSkuAvailabilityInStores = async (projectId, listName, skuId, params) => {
  if (listName !== '') {
    // eslint-disable-next-line no-param-reassign
    params.list = listName;
  }

  return axios({
    url: `/projects/${projectId}/sku/availability/${skuId}/stores`,
    baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
    params
  });
};

export const fetchSkuAvailabilityInStoresRow = async (projectId, listName, params) => {
  if (listName !== '') {
    // eslint-disable-next-line no-param-reassign
    params.list_tab = listName;
  }

  return axios({
    url: `/projects/${projectId}/sku/availability/store`,
    baseURL: `${VUE_APP_BASE_URL}/api/ocean/v3/`,
    params
  });
};

export default {
  fetchSkuAvailabilityInStores
};
